import React, { useState, useEffect, useCallback } from 'react';
import BtnAddHardwareAdmin from "../BtnAddHardware"
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import HardwareFilter from '../HardwareFilters'
import { ActionTable } from '../../ActionTable/ActionTable';
import { listHardwares } from "../../../services/service";
import EditHardwareModal from '../EditHardwareModal';
import DeleteHardwareModal from '../DeleteHardwareModal'
import LinkSelectedHardwareWithLicen from '../LinkSelectedHardwareWithLicence'
import {useAuth} from "../../../services/auth"

const defaultHwModelData = {
    count: 0, results: [], next: null, previous: null
}

export default function HardwareModel() {
    const { user } = useAuth()

    const [hardwareData, setHardwareData] = useState(defaultHwModelData);
    //Hardware Data with company and model name instead of id 

    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);

    const [modalStateEdit, setModalStateEdit] = useState(false);
    const [modalStateDelete, setModalStateDelete] = useState(false);
    const [modalStateLink, setModalStateLink] = useState(false);

    const [modalValue, setModalValue] = useState();

    //This const will reset the index when delete a row 
    const [selectedRows, setSelectedRows] = useState(false)

    const [currentPageSize, setCurrentPageSize] = useState(25);
    const [hardwareFilteredData, setHardwareFilteredData] = useState();

    const parseHwData = (data) => {
        data.results.map((el) => {
            el["company_id"] = el.company.id || el.company
            el["hardware_model_id"] = el.hardware_model.id || el.hardware_model
            el["company"] = el.company.name || el.company
            el["hardware_model"] = el.hardware_model.model || el.hardware_model
            el["is_linked"] = !!el.bwise_license ? "Sim" : "Não"
            return el
        })
        setHardwareData(data)
    }


    const loadHardwares = useCallback(() => {
        setLoading(true);
        listHardwares(currentPage + 1, currentPageSize, { expand: "company,hardware_model" })
            .then((response) => {
                parseHwData(response.data)
            })
            .catch((error) => {
                // TODO: Add an alert notifying the user about this error.
                console.log(error)
            })
            .finally(setLoading(false))
    }, [currentPage, currentPageSize]);

    // Load All Hardware Types
    useEffect(() => {
        loadHardwares()
    }, [currentPage, currentPageSize])

    const hardwareEditlValue = (hwmModel) => {
        setModalStateEdit(true)
        setModalValue(hwmModel)
    }

    const hardwareDeleteValue = (hwmModel) => {
        setModalStateDelete(true)
        setModalValue(hwmModel)
    }

    const hardwareLinkValue = (hw) => {
        setModalStateLink(true)
        setModalValue(hw)
    }

    const hardwareSeeDetails = (valueData) => {
        window.open(`/hardware/${valueData.id}`,'_blank')
    }
    const onHardwareModelCreated = () => {
        loadHardwares()
    }

    // Chamado sempre pelo EditHardwareModal, quando finalizar com sucesso a edição
    const onHardwareEdited = () => {
        // Recarrega os modelos e fecha o modal
        loadHardwares()
        setModalStateEdit(false);
    }

    const onHardwareDeleted = () => {
        loadHardwares()
        setModalStateDelete(false);
    }
    const onHardwareLinked = () => {
        loadHardwares()
        setModalStateLink(false);
    }

    const onPageChange = (newPage) => {
        setCurrentPage(newPage)
    }

    const onPageSizeChange = (newPageSize) => {
        setCurrentPageSize(newPageSize)
        setCurrentPage(0);
    }

    // Will get by id the company name and pass it to the hardwareData
    // hardwareData.results.map((element) => {
    //     getAllCompanyValue(element.company).then((resp) => {
    //         element["company_name"] = resp.data.name
    //     })
    //     return element
    // })

    useEffect(() => {
        if (hardwareFilteredData !== undefined && hardwareFilteredData !== null) {
            parseHwData(hardwareFilteredData)
        }
    }, [hardwareFilteredData])

    return (
        <>
            {modalStateEdit ?
                // Criamos o Modal, passando uma função que será chamada por ele sempre que finalizar a edição
                // (onHardwareEdited). Também passamos uma função (anônima) que será sempre chamada quando ele clicar na opção de fechar
                // Por fim, passamos os valores do hardware a ser editado (hardwareModel), juntamente com o estado atual desse modal (show)
                <EditHardwareModal
                    open={modalStateEdit}
                    setOpen={setModalStateEdit}
                    onHardwareEdited={onHardwareEdited}
                    hardwareModel={modalValue}
                    show={modalStateEdit}
                /> : null}

            {modalStateDelete ?
                <DeleteHardwareModal
                    onHardwareDeleted={onHardwareDeleted}
                    onClose={() => setModalStateDelete(false)}
                    hardwareModel={modalValue}
                    show={modalStateDelete}
                    loadTable={loadHardwares}
                    // This function will set the index to zero 
                    // Props from child to parents 
                    changeSelectedRowValue={selectedRows => setSelectedRows(selectedRows)}
                /> : null}

            {modalStateLink ?
                <LinkSelectedHardwareWithLicen
                    onSeeMore={onHardwareLinked}
                    onClose={() => setModalStateLink(false)}
                    hardwareModel={modalValue}
                    show={modalStateLink}
                />
                : null}
            <Row>
                <Col lg={9}>
                    {/* <HardwareFilter tableData={hardwareData} /> */}

                    <HardwareFilter tableData={hardwareData} childrenToParentValue={tableValue => setHardwareFilteredData(tableValue)} />

                    <ActionTable
                        title={"Hardware"}
                        enableCheck
                        currentPage={currentPage}
                        pageSize={currentPageSize}
                        pageSizeOptions={hardwareData.count < 10 ? [10]
                            :
                            hardwareData.count < 25
                                ? [10, 25]
                                :
                                [10, 25, 40]}
                        count={hardwareData.count}
                        
                        columns={user.is_staff?["id", "name", "company", "hardware_model", "is_linked"]:["id", "name", "hardware_model", "is_linked"]}
                        columnsMap={{
                            id: "ID",
                            name: "Nome",
                            company: "Empresa",
                            hardware_model: "Modelo de Hardware",
                            is_linked: "Possui Licença?"
                        }}
                        rows={hardwareData.results}
                        onPageChange={onPageChange}
                        onPageSizeChange={onPageSizeChange}
                        onEditSelected={(hw) => hardwareEditlValue(hw)}
                        // OPEN EDIT MODAL 
                        onDeleteSelected={(hw) => { hardwareDeleteValue(hw) }}
                        //this value will set the index to zero after delete a row 
                        SetindexToZero={selectedRows}
                        // This props children to parents will check if a row was selected  and will pass his value 
                        onLinkSelected={(hw) => hardwareLinkValue(hw)}
                        setLinkIcon={true}
                        setSeeMoreIcon={true}
                        handleSeeDetails={hardwareSeeDetails}
                    />
                </Col>
                <Col lg={3}>
                    <Row>
                        <BtnAddHardwareAdmin onHardwareModelCreated={onHardwareModelCreated} />
                        {/* <BtnLinkLicenseAdmin sx={{marginTop: 1}}/> */}
                    </Row>
                </Col>
            </Row>
        </>
    )
}